module.exports = __webpack_public_path__ + "files/sharepoint-developer-2010.51b56e59.pdf";